










































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import TextField from '@/components/atoms/TextField/TextField.vue';
import eventBus from '@/utils/eventBus';

@Component({
  components: { TextField },
  $_veeValidate: {
    value() {
      const { value } = this as any;
      return value;
    },
    name() {
      const { name } = this as any;
      return name;
    }
  }
})
export default class Autocomplete extends Vue {
  @Prop({ default: false }) readonly clearOnSelect!: boolean;
  @Prop(String) readonly name!: string;
  @Prop() value!: any;
  @Prop() initialValue!: any;
  @Prop(String) search!: string;
  @Prop(String) readonly label!: string;
  @Prop(String) readonly rightText?: string;
  @Prop(String) readonly placeholder!: string;
  @Prop({ default: false }) readonly error!: boolean;
  @Prop({ default: '' }) readonly rules?: string;
  @Prop(String) readonly tippy?: string;
  @Prop({ default: 600 }) readonly delay?: number;
  @Prop({ default: [] }) readonly options?: {
    id: string;
    label: string;
    [key: string]: any;
  }[];
  @Prop({ default: false }) readonly disabled?: boolean;

  inputValue: string = '';
  debouncedValue: string = '';
  timeout: any;

  open: boolean = false;

  @Watch('inputValue')
  debounceCity() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(() => {
      if (this.debouncedValue !== this.inputValue) {
        this.$emit('search', this.inputValue);
        this.debouncedValue = this.inputValue;
      }
    }, this.delay);
  }

  @Watch('open')
  focusInput() {
    if (this.open) {
      const component = this.$refs.field as Vue;
      const input = component.$el.querySelector('input');

      if (input) {
        input.focus();
      }
    }
  }

  onBlur($event?: any) {
    if ($event) {
      $event.stopPropagation();
    }
    this.open = false;
  }

  select(option: any, $event: any) {
    $event.stopPropagation();
    this.inputValue = this.clearOnSelect ? '' : option.label;
    this.$emit('input', option);
    this.open = false;
  }

  openOptions() {
    setTimeout(() => {
      this.open = true;
    });
  }

  closeOptions() {
    setTimeout(() => {
      this.open = false;
    });
  }

  clearValue() {
    this.inputValue = '';
    this.debouncedValue = '';
  }

  created() {
    if (this.initialValue) {
      this.inputValue = this.initialValue;
    }

    eventBus.$on('closeAutocomplete', this.closeOptions);
    eventBus.$on('openAutocomplete', this.openOptions);
    eventBus.$on('clearAutocomplete', this.clearValue);
  }

  destroy() {
    eventBus.$off('closeAutocomplete', this.closeOptions);
    eventBus.$off('openAutocomplete', this.openOptions);
    eventBus.$off('clearAutocomplete', this.clearValue);
  }
}
